"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _BadgesOverviewPanel = _interopRequireDefault(require("./BadgesOverviewPanel"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BadgeOverviewModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BadgeOverviewModal, _Component);

  var _super = _createSuper(BadgeOverviewModal);

  function BadgeOverviewModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BadgeOverviewModal);
    _this = _super.call(this, props);
    _this.state = {
      badgesList: [],
      loading: true
    };
    return _this;
  }

  (0, _createClass2.default)(BadgeOverviewModal, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        var userId;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userId = this.props.userId;
                _context.next = 3;
                return _axios.default.get("/settings/badge/getBadgesList?userid=".concat(userId)).then(function (response) {
                  return _this2.setState({
                    badgesList: response.data,
                    loading: false
                  });
                }).catch(function () {
                  return _this2.setState({
                    loading: false
                  });
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var state = this.state;
      return (0, _preact.h)(_BadgesOverviewPanel.default, {
        badgeList: state.badgesList,
        loading: state.loading
      });
    }
  }]);
  return BadgeOverviewModal;
}(_preact.Component);

var _default = BadgeOverviewModal;
exports.default = _default;